import { DialogType } from '@tableau/widgets';
import * as React from 'react';

import { ModalInstance, ReactModalService } from '~src/commonInfra/dialogs/ReactModalService';
import { ISiteAuthenticationSettings } from '~src/settings/siteAuthSettings/services/SiteAuthenticationSettingsService';
import { ISiteSettingsForServerAdmin } from '~src/settings/types/ISite';
import { ISiteSettingsForSiteAdmin } from '~src/settings/types/ISiteSettingsForSiteAdmin';
import { IEditableServerSettings } from '~src/ts/ServerApi/types/IEditableServerSettings';

import { EditSiteSettingDialog, EditSiteSettingDialogProps } from '../components/EditSiteSettingDialog';

const editSiteSettingsDialogStyle: React.CSSProperties = {
  maxHeight: '574px',
  maxWidth: '951px'
};

export  function showEditSiteDialog(settings: EditSiteSettings): Promise<any> {
  let modalInstance: ModalInstance;
  const dialogProps: EditSiteSettingDialogProps = {
    dismiss: () => modalInstance && modalInstance.dismiss(),
    close: (result: any) => modalInstance && modalInstance.close(result),
    ...settings
  };
  modalInstance = ReactModalService.open({
    type: DialogType.Uber,
    dialogContent: <EditSiteSettingDialog {...dialogProps}/>,
    testId: 'editSiteSettingDialog',
    dialogStyle: editSiteSettingsDialogStyle,
    shouldNotSetDefaultWidth: true
  });

  return modalInstance.result;
}

export interface EditSiteSettings {

serverSettings: IEditableServerSettings;
siteSettings: ISiteSettingsForSiteAdmin;
siteSettingsForServerAdmin: ISiteSettingsForServerAdmin;
siteAuthenticationSettings: ISiteAuthenticationSettings;
}
